import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css } from "../../../lib/theming/Emotion";
export var labelSizeMixin = function labelSizeMixin(tokenInputPaddingY, tokenInputPaddingX) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: ", " ", ";\n  "])), tokenInputPaddingY, tokenInputPaddingX);
};
export var inputSizeMixin = function inputSizeMixin(fontSize, lineHeight) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    height: ", ";\n    line-height: ", ";\n  "])), fontSize, lineHeight, lineHeight);
};